import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from './UIHelpers';

const ConsultantsUIContext = createContext();
const { initialFilter } = UIHelpers();

export function useFunctionalitiesUIContext () {
    return useContext(ConsultantsUIContext);
}

export const ConsultantsUIConsumer = ConsultantsUIContext.Account;

export function ConsultantsUIProvider ({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [functionalities, setFunctionalities] = useState([]);
    const [consultants, setConsultants] = useState([]);
    const [fetchData, setFetchData] = useState(false);

    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        consultants,
        setConsultants,
        setQueryParamsBase,
        setQueryParams,
        functionalities,
        setFunctionalities,
        fetchData,
        setFetchData
    };

    return <ConsultantsUIContext.Provider value={value}>{children}</ConsultantsUIContext.Provider>;
}
